import { createSlice } from '@reduxjs/toolkit';

export interface LearningPathwayState {
	step: number,
	name: string,
	franchise_id: number,
	franchise_name: string,
	subject_id: number,
	subject_name: string,
	status: string,
	modules: [],
	pathway: [];
	student_assigned: number;
}

const initialState: LearningPathwayState = {
	step: 1,
	name: null,
	franchise_id: null,
	franchise_name: null,
	subject_id: null,
	subject_name: null,
	status: null,
	modules: [],
	pathway: [],
	student_assigned: null
};

export const LearningPathwaySlice = createSlice({
	name: 'learning-pathway',
	initialState,
	reducers: {
		setStep: (state, {payload}) => {
			state.step = payload;
		},
		setPreferenceData: (state, {payload}) => {
			state.name = payload.name;
			state.franchise_id = payload.franchise_id;
			state.franchise_name = payload.franchise_name;
			state.subject_id = payload.subject_id;
			state.subject_name = payload.subject_name;
			state.status = payload.status;
			state.student_assigned = Number(payload?.student_assigned);
		},
		loadModules: (state, { payload }) => {
			state.modules = payload;
		},
		loadPathway: (state, { payload }) => {
			state.pathway = payload;
		},
		clearPathwayStore: () => initialState,
	}
});

export const { setStep, setPreferenceData, loadModules, loadPathway, clearPathwayStore} = LearningPathwaySlice.actions;

export default LearningPathwaySlice.reducer;